import { padStart } from 'lodash';
// eslint-disable-next-line no-restricted-imports
import moment from 'moment';

export function formatDuration(duration, unit = 'ms') {
  const sign = duration < 0 ? '-' : '';
  const momentDuration = moment.duration(duration, unit);
  const days = Math.floor(momentDuration.asDays());
  const dayString = days ? `${days}d ` : '';
  const hours = momentDuration.hours();
  const hoursWithLeadingZero = padStart(hours, 2, '0');
  const hourString = hours ? `${hoursWithLeadingZero}:` : '';
  const minutes = Math.abs(momentDuration.minutes());
  const minutesWithLeadingZero = padStart(minutes, 2, '0');
  const seconds = Math.abs(momentDuration.seconds());
  const secondsWithLeadingZero = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${sign}${dayString}${hourString}${minutesWithLeadingZero}:${secondsWithLeadingZero}`;
}

export function withIndefiniteArticle(text, nowrap = false) {
  const separator = nowrap ? '\u00A0' : ' ';
  const article = 'AEIOUYaeiouy'.includes(text[0]) ? 'an' : 'a';

  return `${article}${separator}${text}`;
}
